import { Redirect, Route, Switch } from "react-router-dom";
import ErrorPage from "./errorPage";
import FileUpload from "./fileUpload";
import PhoneVerify from "./phoneVerify";
import ResultPage from "./resultPage";
import { useRouteQuery } from "../../utils";

export default function WorkUpload() {
  const templateCode = useRouteQuery("templateCode");
  return (
    <Switch>
      <Redirect
        exact
        path="/work-upload/:token"
        to={{
          pathname: "/work-upload/verify/:token",
          search: templateCode ? `?templateCode=${templateCode}` : "",
        }}
      />
      <Route path="/work-upload/verify/:token">
        <PhoneVerify />
      </Route>
      <Route path="/work-upload/upload/:token">
        <FileUpload />
      </Route>
      <Route path="/work-upload/result/:token">
        <ResultPage />
      </Route>
      <Route path="/work-upload/error/:token">
        <ErrorPage />
      </Route>
    </Switch>
  );
}
